import React, { useEffect } from "react";
import ArchieveListItem from "./ArchieveListItem/ArchieveListItem";
import { Button, LoadingSpinner } from "pepsico-ds";
import { useAppDispatch, useAppSelector } from "../../../../hooks/app";
import {
  getAllArchivedChats,
  unArchiveAllChats,
} from "../../../../redux/reducers/chatActions/archivedChatsReducer";
import { unwrapResult } from "@reduxjs/toolkit";
import { useNavigate, useParams } from "react-router-dom";
import { CloseOutRadioActions } from "../../../../redux/closeoutslice/closeOutRadioSlice";
import {
  setActiveChat,
  setActiveQuestion,
  setIsArchived,
  setShowWelcomeText,
} from "../../../../redux/actions/chatActions";
import { setActiveTab } from "../../../../redux/reducers/chatHistoryActionReducer";
import { setFavouriteSession } from "../../../../redux/reducers/chatFavourites/chatFavoriteReducer";

function ArchieveList() {
  const containerRef = React.useRef<HTMLDivElement>(null);
  const [page, setPage] = React.useState(1);
  const dispatch = useAppDispatch();
  const { isLoading, isError, data, total, isFetchingMore, hasFetchedAll } =
    useAppSelector((state) => state.archievedChats);
  const navigate = useNavigate();
  const goToDefaultView = React.useCallback(() => {
    dispatch({ type: "CLEAR_MESSAGES" });
    dispatch(setFavouriteSession({}));
    dispatch(setActiveChat(""));
    dispatch(setActiveQuestion("", ""));
    dispatch(setShowWelcomeText(true));
    dispatch(setIsArchived(false));
    navigate(`/spend-wise-hub/chat-assistant`, {
      replace: true,
    });
  }, [dispatch, navigate]);
  useEffect(() => {
    //todo: fetch archive chats from API
    dispatch(getAllArchivedChats({ page: 1 }))
      .then(unwrapResult)
      .then((result) => {
        const response = result.data.data;
        if (Array.isArray(response) && response.length > 0) {
          dispatch(setIsArchived(true));
          navigate(`/spend-wise-hub/chat-assistant/${response[0].chat_id}`, {
            replace: true,
          });
        } else {
          goToDefaultView();
        }
      });
  }, [dispatch]);

  const unArchiveAllHandler = () => {
    dispatch(unArchiveAllChats())
      .then(unwrapResult)
      .then(() => {
        dispatch(setIsArchived(false));
        dispatch(
          CloseOutRadioActions.setSnackBarMessage({
            message: "All Chats unarchived successfully.",
            severity: "success",
          })
        );
        dispatch(setActiveTab("chatHistory"));
        goToDefaultView();
      })
      .catch(() => {
        dispatch(
          CloseOutRadioActions.setSnackBarMessage({
            message: "Failed Chat unarchived",
            severity: "error",
          })
        );
      });
  };
  // when you scroll the containerRef, it should load more chats
  const handleScroll = () => {
    if (
      containerRef.current &&
      containerRef.current.scrollHeight - containerRef.current.scrollTop <=
        containerRef.current.clientHeight + 50
    ) {
      if (isFetchingMore) return; // Prevent multiple fetches
      if (hasFetchedAll) return; // If all data has been fetched, do not fetch more
      setPage((prevPage) => prevPage + 1);
      dispatch(getAllArchivedChats({ page: page + 1 }));
    }
  };

  return (
    <div style={{ flex: 1, position: "relative" }}>
      {isLoading ? (
        <LoadingSpinner
          style={{ color: "#005cbc", margin: "0 auto" }}
          size={{
            height: "20px",
            width: "20px",
          }}
        />
      ) : isError ? (
        <p style={{ textAlign: "center" }}>Error loading archived chats</p>
      ) : total === 0 ? (
        <p style={{ textAlign: "center" }}>No archived chats found</p>
      ) : (
        <>
          <div
            style={{ height: "55vh", overflowY: "auto" }}
            ref={containerRef}
            onScroll={handleScroll}
          >
            {data?.map((chat) => (
              <ArchieveListItem
                key={chat.chat_id}
                sessionName={chat.session_name}
                chatId={chat.chat_id}
                updatedDate={chat.updated_date}
              />
            ))}
          </div>
          {isFetchingMore && (
            <LoadingSpinner
              style={{ color: "#005cbc", margin: "0 auto" }}
              size={{
                height: "20px",
                width: "20px",
              }}
            />
          )}
          {total ? (
            <Button
              variant="tertiary"
              style={{
                width: "100%",
                justifyContent: "center",
                position: "absolute",
                bottom: 0,
                zIndex: 100,
              }}
              iconLeading="unarchive"
              onClick={unArchiveAllHandler}
            >
              Unarchive All
            </Button>
          ) : null}
        </>
      )}
    </div>
  );
}

export default ArchieveList;
